import { PATH_SEPARATOR } from "./studioTypes";

/** A finding title shortened for the row. The detector writes every node with its full
 *  ancestry ("Fabric care › Downy › Beads › Odor Blasters breaks the Fabric care › Downy ›
 *  Beads › Original block in two"); the row shows the nodes ("Odor Blasters breaks the Original
 *  block in two") and the ancestry once, as `context`. The ancestry is the flag's own scope
 *  path minus its last node, so nothing is guessed from the wording. */
export interface ShortFlagTitle {
  title: string;
  /** The ancestry removed from the title; null when there was none to remove. */
  context: string | null;
}

export const shortFlagTitle = (title: string, scopePath: readonly string[]): ShortFlagTitle => {
  // Longest ancestry that the title actually spells out, so a title written one level above
  // the flag's scope still shortens.
  for (let depth = scopePath.length - 1; depth >= 1; depth -= 1) {
    const prefix = scopePath.slice(0, depth).join(PATH_SEPARATOR) + PATH_SEPARATOR;
    if (!title.includes(prefix)) continue;
    return {
      title: title.split(prefix).join("").replace(/\s+/g, " ").trim(),
      context: scopePath.slice(0, depth).join(PATH_SEPARATOR),
    };
  }
  return { title, context: null };
};
